import CompanyWorkingEditComponent from "../components/CompanyWorkingEdit";
import useCompanyWorking from "../hooks/useCompanyWorking";

const CompanyWorkingEdit = (props) => {
  const useCompanyWorkingProps = useCompanyWorking(props);
  return <CompanyWorkingEditComponent {...useCompanyWorkingProps} />;
};

export default CompanyWorkingEdit;
